module.exports = __webpack_public_path__ + "static/based-segmentation-5714cd8ed8f69b55b959ee6fd41baccf.png";